import { updates } from "@/mocks/home";

export default function Updates() {
  return (
    <section id="updates" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="text-xs md:text-sm font-semibold tracking-widest text-primary-600 uppercase">
            Updates
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">内容动态更新</h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
            本页会随渠道与工具的变化持续整理与修订，下面记录最近的调整方向，便于你了解哪些内容是新补充的。
          </p>
        </div>

        <ol className="mt-10 space-y-4">
          {updates.map((item) => (
            <li
              key={item.date}
              className="flex flex-col sm:flex-row gap-3 sm:gap-5 rounded-lg border border-background-200 bg-background-50 p-5 hover:border-primary-300 transition-colors"
            >
              <div className="sm:w-32 shrink-0">
                <span className="inline-block px-2.5 py-1 rounded-md bg-accent-100 text-accent-900 text-xs font-semibold whitespace-nowrap">
                  {item.tag}
                </span>
                <p className="mt-2 text-xs text-foreground-500 whitespace-nowrap">{item.date}</p>
              </div>
              <div className="flex-1">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}